export default __webpack_public_path__ + "static/media/wasp_p_logo.72cbd12f.svg";